<template>
  <div class="p-4">
    <div class="flex justify-between items-center mb-3">
      <span class="font-medium text-gray-600 capitalize">
        {{ call.customerName }}
      </span>
      <button
        class="ml-2 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        @click="viewCustomer"
      >
        View
      </button>
    </div>
    <div class="w-full border-t border-gray-300 mb-3" />
    <div
      v-if="isInProgress"
      class="flex justify-between"
    >
      <div class="flex items-center">
        <button
          class="ml-2 inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          @click="toggleMute"
        >
          <volume-up v-if="call.muted" />
          <volume-off v-if="!call.muted" />
        </button>
        <div class="px-2 text-sm truncate">
          <span class="font-medium text-indigo-600 ">{{ call.phoneNumber }}</span><br>
          <span class="italic"><call-timer :enabled="true" /></span>
        </div>
      </div>
      <button
        class="ml-2 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        @click="disconnectCall"
      >
        Hang up
      </button>
    </div>
    <div
      v-if="isPending"
    >
      <div class="py-4 text-sm font-medium text-indigo-600 truncate">
        {{ call.phoneNumber }}
      </div>
      <div class="flex justify-between items-center">
        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          @click="acceptCall"
        >
          Accept
        </button>

        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
          @click="ignoreCall"
        >
          Ignore
        </button>

        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          @click="rejectCall"
        >
          Reject
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  setup () {
    const callConsole = useCallConsoleStore()
    return { callConsole }
  },
  computed: {
    isPending () {
      return this.call.status === 'PENDING'
    },
    isInProgress () {
      return this.call.status === 'IN_PROGRESS'
    }
  },
  methods: {
    acceptCall () {
      this.callConsole.acceptCall({ id: this.call.id })
    },
    rejectCall () {
      this.callConsole.rejectCall({ id: this.call.id })
    },
    ignoreCall () {
      this.callConsole.ignoreCall({ id: this.call.id })
    },
    disconnectCall () {
      this.callConsole.disconnectCall({ id: this.call.id })
    },
    toggleMute () {
      this.callConsole.toggleMute({ id: this.call.id })
    },
    viewCustomer () {
      this.$router.push({
        path: '/lead/'
      })
    }
  }
}
</script>
